// ─── About ───────────────────────────────────────────────────────────────────

export default function About() {
  return (
    <section className="section about" id="about">
      <div className="about__bg-text">CELESTIAL</div>
      <div className="container about__inner">
        <div className="about__visual">
          <img
            src="/assets/slider/railways.jpg"
            alt="Alberta fields"
            className="about__img about__img--main"
          />
          <img
            src="/assets/slider/railway-3.jpeg"
            alt="Grains close-up"
            style={{  height: "40vh" , width:"70vh"}}
            className="about__img about__img--accent"
          />
          <div className="about__badge" style={{ top: "65%",left: "80%" }}>
            <span className="about__badge-num">1883</span>
            <span className="about__badge-sub">Alberta's Railway Era</span>
          </div>
        </div>
        <div className="about__copy">
          <span className="section__label">Our Story</span>
          <h2 className="section__title">
            Celestial Grains:
            <br />
            Alberta's Timeless Harvest
          </h2>
          <p>
            Founded in Calgary's vibrant heart, Celestial Grains draws from Alberta's storied agricultural legacy — from First Nations cultivating prairies millennia ago, to 18th–19th century fur traders and ranchers. The 1883 Canadian Pacific Railway and 1905 provincial birth transformed buffalo plains into a global breadbasket, with Dust Bowl resilience yielding today's bountiful fields. This mirrors our journey.
          </p>
          <p>
            From a Calgary entrepreneur's passion for pulses and lentils, we bridge Alberta's prairies to thriving markets in India, the UK, Germany, UAE, South Korea, South America, Africa, and beyond. Our name captures the endless skies nurturing these crops, symbolizing purity, reliability, and boundless potential.
          </p>
          <p>
            Partnering with trusted local farmers and seasoned logistics experts, we master every link in the supply chain — from farm-gate sourcing and rigorous quality checks, to efficient container loading, customs clearance, and on-time delivery worldwide. We deliver premium, traceable lentils via streamlined export operations — honoring Alberta's evolution from Fort Macleod outposts to agri-export leader.
          </p>
          <p>
            We're stewards of this enduring spirit: quality, sustainability, and trusted global ties.
          </p>
          <div className="about__pillars">
            {["Quality", "Sustainability", "Trust", "Traceability"].map((p) => (
              <div key={p} className="pillar">
                <div className="pillar__dot" />
                <span>{p}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}